// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2UJ0M","inputWrap":"Table_inputWrap__3gINb","col":"Table_col__Tz6cb","bmiTooltip":"Table_bmiTooltip__HqBLJ"};